import Swiper from 'components/Swiper'
import TextBody from 'components/TextBody'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import { View } from 'components/View.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import starIcon from 'components/Icon/icons/star.svg'
import React from 'react'
import {
  defineMessages,
  FormattedMessage
} from 'react-intl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'

import { rangeArrayUtil } from 'packages/src'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import Block from 'components/Block/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'

const messages = defineMessages({
  reviewedByName: {
    id: 'AppReviews.reviewedByName',
    defaultMessage: 'Reviewed by {name}'
  },
  title: {
    id: 'AppReviews.title',
    defaultMessage: 'What Our Customers Are Saying'
  }
})

const REVIEWS = [
  {
    reviewer: 'Sarah M.',
    text: 'It literally takes me 10 seconds to log a meal. I used to hate calorie tracking, now I don’t even think about it.'
  },
  {
    reviewer: 'Daniel R.',
    text: 'Faster and simpler than MyFitnessPal. I just snap a pic and the calories pop up in seconds.'
  },
  {
    reviewer: 'Tran G.',
    text: 'Great workout app! Thank you Gymaholic, it allows me to get back on track after months of not exercising.'
  },
  {
    reviewer: 'Jessica L.',
    text: 'I love how accurate the meal scanner is. Macros are right there and I don’t waste time searching through endless food lists.'
  },
  {
    reviewer: 'Mark D.',
    text: 'I’ve lost 12 lbs in 2 months just by finally staying consistent with tracking. This app made it effortless.'
  }
]

// const REVIEWS = [
//   {
//     reviewer: 'Peachy F.',
//     text: 'Best app to get fit at home! Such an effective app. I’m following the home workouts and they’re so intense.',
//     link: 'https://apps.apple.com/ca/app/gymaholic-training/id1409925959?see-all=reviews'
//   },
//   {
//     reviewer: 'Lorena B.',
//     text: 'The amount of knowledge and love they put in building this app is superb, well thought and well done, bravo!!',
//     link: 'https://play.google.com/store/apps/details?id=com.gymaholic.training'
//   },
//   {
//     reviewer: 'Tran G.',
//     text: 'Great workout app! Thank you Gymaholic, it allows me to get back on track after months of not exercising.',
//     link: 'https://apps.apple.com/ca/app/gymaholic-training/id1409925959?see-all=reviews'
//   },
//   {
//     reviewer: 'William S.',
//     text: 'Intuitive and easy to follow! Keeps me accountable without having to put in excessive effort into tracking my workouts or having to follow complicated routines. The layout is also super minimalistic.',
//     link: 'https://play.google.com/store/apps/details?id=com.gymaholic.training'
//   },
//   {
//     reviewer: 'Itskari F.',
//     text: 'Recommended 100%. It’s really easy to use and great training programs!',
//     link: 'https://apps.apple.com/ca/app/gymaholic-training/id1409925959?see-all=reviews'
//   }
// ]

const REVIEWS_ANALYTIC_EVENT = {
  VIEW_REVIEWER: 'VIEW_REVIEWER',
  NEXT_REVIEW: 'NEXT_REVIEW',
  PREVIOUS_REVIEW: 'PREVIOUS_REVIEW'
}

export function AppReviews () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()

  // const onClickReviewer = () => {
  //   logEventAnalyticsUtil(REVIEWS_ANALYTIC_EVENT.VIEW_REVIEWER)
  // }
  return (

    <Block
      style={{
        backgroundColor: 'white'
      }}
    >

      <View centered>
        <TextTitleCompressedHeavy>
          {formatMessageIntlUtil(intl, messages.title)}
        </TextTitleCompressedHeavy>
      </View>
      <Swiper
        style={{
          width: isSmallScreen ? '100%' : 'auto'
        }}
        autoplay
        renderArrows
        rightArrowPressEvent={REVIEWS_ANALYTIC_EVENT.NEXT_REVIEW}
        leftArrowPressEvent={REVIEWS_ANALYTIC_EVENT.PREVIOUS_REVIEW}
      >
        {
          REVIEWS.map(({
            text,
            link,
            reviewer
          }) => {
            return (
              <View
                key={reviewer}
                px={isSmallScreen
                  ? 8
                  : 16}
                centered
                h={42}
              >
                <TextTitleCompressedHeavy ta>“{text}“</TextTitleCompressedHeavy>
                <View
                  mt={4}
                  row
                >
                  {rangeArrayUtil(
                    0,
                    5
                  )
                    .map((
                      _,
                      index
                    ) => (
                      <img
                        key={index}
                        src={starIcon}
                        alt=''
                        style={{
                          width: '1.40em',
                          height: '1.40em',
                          marginRight: '0.19em'
                        }}
                      />
                    ))}
                </View>
                <View
                  mt
                  row
                  ac
                >
                  <TextBody>
                    <FormattedMessage
                      {...messages.reviewedByName}
                      values={{
                        name: (
                          <b>
                            <span>
                              {reviewer}
                            </span>
                            {/* <a */}
                            {/*  href={link} */}
                            {/*  target='_blank' */}
                            {/*  rel='noreferrer' */}
                            {/*  onClick={() => onClickReviewer(reviewer)} */}
                            {/* > */}
                            {/*  {reviewer} */}
                            {/* </a> */}
                          </b>
                        )
                      }}
                    />
                  </TextBody>
                </View>
              </View>
            )
          })
        }
      </Swiper>
    </Block>
  )
}
